import {ContentPage} from 'new-models';
import {createContext} from 'react';

interface IFranchiseContextProps extends ContentPage {}

export const FranchiseContext = createContext<IFranchiseContextProps>({} as IFranchiseContextProps);
